<div class="ad-page-header-custom">
    <div class="container">
        <h1>Email Validation</h1>
    </div>
</div>
<div class="password-reset">
    <div class="container form-holder">
        <p *ngIf="successful" style="color:#000;font-size:20px; margin-bottom: 30px;">Your email ({{emailAddress}}) has been verified successfully</p>

        <p *ngIf="failure" class="has-feedback" style="color:#c00;font-size:20px; margin-bottom: 30px;">
            Your email could not be verified. Your link may have expired. Or, if you requested to re-send the verification email, be sure to use the most recent verification link from Dice. <a href="/dashboard">Re-send</a> verification email.

        </p>

    </div>
</div>

<!-- <form (ngSubmit)="validateAuthCode(codeform)" #codeform="ngForm">
    <div class="form-group">
      <label for="code">Code</label>
      <input type="text" name="code" id="code" ngModel class="form-control" required>
    </div>
    <button type="submit" class="btn btn-primary">Validate Code</button>
  </form> -->
